import React from "react";
import TradeInputForm from "./TradeInputForm";

const TradeAnalyzerPage = () => {
  return (
    <div className="min-h-screen bg-sky-950 shadow-black shadow-2xl">
      <TradeInputForm />
    </div>
  );
};

export default TradeAnalyzerPage;
